import { useEffect, useRef } from 'react';
import { cn } from '@/lib/utils';

const ERROR_RE = /\b(error|fatal|panic|FAIL)\b/i;
const WARN_RE = /\b(warn|warning)\b/i;

export function JobLogViewer({ lines }: { lines: string[] }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // jsdom doesn't implement scrollTo; guard and fall back to assignment.
    if (typeof el.scrollTo === 'function') {
      el.scrollTo({ top: el.scrollHeight });
    } else {
      el.scrollTop = el.scrollHeight;
    }
  }, [lines]);

  return (
    <div
      ref={ref}
      className="font-mono text-xs bg-black text-white rounded-md p-3 h-96 overflow-y-auto whitespace-pre"
      data-testid="job-log-viewer"
    >
      {lines.length === 0 ? (
        <div className="text-white/40">Waiting for output…</div>
      ) : (
        lines.map((line, i) => (
          <div
            key={i}
            className={cn(
              ERROR_RE.test(line) && 'text-red-400',
              !ERROR_RE.test(line) && WARN_RE.test(line) && 'text-yellow-300',
            )}
          >
            {line}
          </div>
        ))
      )}
    </div>
  );
}
